import axios from 'axios';
import { loadAbort } from 'utilities';

const route = import.meta.env.VITE_API_URL;
type appId = 'mentoring' | 'coaching';

export const getCoachComboData = (appId: appId) => {
  const controller = loadAbort();
  const url = `${route}/coach/input`;
  return {
    call: () =>
      axios.get(url, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const getCoacheeComboData = (appId: appId) => {
  const controller = loadAbort();
  const url = `${route}/coachee/input`;
  return {
    call: () =>
      axios.get(url, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const getCompanyComboData = (appId: appId) => {
  const controller = loadAbort();
  const url = `${route}/company/input`;
  return {
    call: () =>
      axios.get(url, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const getUsersClaraComboData = () => {
  const controller = loadAbort();
  const url = `${route}clara/input`;
  return {
    call: () =>
      axios.get(url, {
        signal: controller.signal,
      }),
    controller,
  };
};
